import { FaClock } from "react-icons/fa6"
import ResponsiveTable from "../components/table"
import Video from "../components/campusLife/video"
import { useSelector } from "react-redux"
import { DecodeHtml } from "../utils/decodeHtml"
import YouTubeEmbed from "../utils/youtubeEmbed"

const OperatingHours = () => {

    const state = useSelector(state => state.campusLifeTab)
    const operatingHours = state?.data?.properties
    const operatingHoursDescription = DecodeHtml({ html: operatingHours?.operatingHoursDescription?.markup })
    const operatingHoursDuringSemester = DecodeHtml({ html: operatingHours?.operatingHoursDuringSemester?.markup })
    const operatingHoursDuringSemesterBreak = DecodeHtml({ html: operatingHours?.operatingHoursDuringSemesterBreak?.markup })
    const youtubeLinkURL = operatingHours?.youtubeLinkURL

    const table =
    {
        header: ["During Semester", "During Semester Break"],
        content: [
            [
                <span key="1" className="flex item-center gap-2"><FaClock size={25} />{operatingHoursDuringSemester}</span>,
                <div key="2" className="flex item-start gap-2">
                    <FaClock size={25} />
                    <div className="flex flex-col gap-1 ">
                        {
                            operatingHoursDuringSemesterBreak
                        }
                    </div>
                </div>
            ]
        ]
    }

    return (
        <div className="flex flex-col items-center gap-5 py-8">
            <h1 className="w-auto  text-center text-slate-900 text-4xl font-bold font-['Inter'] capitalize">IRC Putrajaya & KSHAS Operating Hours</h1>
            {/* <ul className="flex flex-col items-center gap-2 list-disc">
                {
                    bullets.map((bullet, index) => (
                        <li key={index} className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal list-disc list-inside">{bullet}</li>
                    ))
                }
            </ul> */}
            {operatingHoursDescription}
            <div className="w-full flex items-center justify-center">
                <ResponsiveTable headers={table.header} contents={table.content} />
            </div>
            <div className="w-full max-w-5xl h-[20rem] my-5 2xl:max-w-7xl 2xl:h-[40rem] overflow-hidden rounded-2xl  bg-gray-200">
                <YouTubeEmbed videoUrl={youtubeLinkURL} />
            </div>
        </div>
    )
}

export default OperatingHours